import React from "react";
import {
    Text,
    View,
    StyleSheet,
    Image,
    TextInput,
    TouchableOpacity,
    KeyboardAvoidingView,
    Platform,
    ScrollView, ToastAndroid,
} from "react-native";
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";
import Config from "../../Config";
import axios from "axios";
import Toast from "../Components/Toast";
import * as Linking from 'expo-linking';


import SwitchToggle from "../Components/SwitchToggle";
const Login = ({ navigation }) => {

    let [phone,setPhone] = React.useState('');
    let [refcode,setrefcode] = React.useState('');
    let [disable,setDisable] = React.useState(false);
    let [refer,setRefer] = React.useState(false);


    const ajax = async ()=>{
        try {
            setDisable(true);
            let formData = new FormData();
            formData.append('phone', phone);
            formData.append('refcode', refcode);

            let res = await axios.post(
                `${Config.api}/auth/phone`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            setDisable(false);


            if(res.data.code == 1){
                navigation.navigate("Code", {
                    phone: phone,

                });
            }else{
                Toast(res.data.error);
                console.log(res.data);
            }
        }catch(err){
            alert(`Error: ${JSON.stringify(err)}`);
        }


    }



    return (
        <View
            style={styles.container}
        >
            <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
                <View style={styles.header}>
                    <Image
                        resizeMode={"stretch"}
                        fadeDuration={999}
                        style={{
                            width: RFValue(250),
                            height: RFValue(250),
                        }}
                        source={require("../../assets/images/login.png")}
                    />
                </View>
                <View style={styles.body}>
                    <Text style={styles.label}>شماره موبایل</Text>
                    <View style={styles.input}>
                        <TextInput
                            placeholderTextColor={"#B1B1B1"}
                            placeholder={"شماره موبایل خود را وارد کنید"}
                            onChangeText={setPhone}
                            value={phone}
                            style={{
                                direction: "rtl",
                                fontFamily: "yk",
                                textAlign: "center",
                                ...(Platform.OS !== 'web' && { letterSpacing: 3 }), // شرط برای حذف letterSpacing در وب
                                backgroundColor: "white",
                                width : '100%',
                                minHeight: RFValue(40),
                            }}
                            keyboardType={"numeric"}
                            maxLength={11}
                        />
                    </View>
                    <View style={{flexDirection : "row", alignItems : "center"}}>
                        <SwitchToggle
                            onToggle={(value) => setRefer(value)}
                        />
                        <Text style={styles.refer}>
                            کد معرف دارم
                        </Text>
                    </View>

                    {refer &&
                        <View style={styles.input}>
                            <TextInput
                                placeholderTextColor={"#B1B1B1"}
                                placeholder={" کد معرف یا شماره موبایل معرف  خود را وارد کنید"}
                                onChangeText={setrefcode}
                                value={refcode}
                                style={{
                                    fontSize: RFValue(10),
                                    direction: "rtl",
                                    fontFamily: "yk",
                                    textAlign: "center",
                                    ...(Platform.OS !== 'web' && { letterSpacing: 3 }), // شرط برای حذف letterSpacing در وب
                                    backgroundColor: "white",
                                    width : '100%',
                                    minHeight: RFValue(30),
                                }}
                                keyboardType={"default"}
                                maxLength={11}
                            />
                        </View>
                    }


                    <TouchableOpacity onPress={()=>Linking.openURL('https://himoralanguagecenter.com/rules')}>
                        <Text style={styles.rule}>با ورود به اپلیکیشن، شما با قوانین و مقررات هیمورا موافقت می‌کنید</Text>
                    </TouchableOpacity>
                    <View style={{ flex: 1, justifyContent: "center" }}>
                        {phone.length == 11 ?
                            <>
                                {disable ?
                                    <TouchableOpacity
                                        disabled={true}
                                        style={styles.button}
                                    >
                                        <Text style={styles.buttonText}>در حال ارسال ... </Text>
                                    </TouchableOpacity>
                                    :
                                    <TouchableOpacity
                                        disabled={false}
                                        onPress={ajax}
                                        style={styles.button}
                                    >
                                        <Text style={styles.buttonText}>ورود </Text>
                                    </TouchableOpacity>
                                }

                            </>
                            :
                            <TouchableOpacity
                                disabled={true}
                                onPress={ajax}
                                style={styles.button}
                            >
                                 <Text style={styles.buttonText}>ورود </Text>
                            </TouchableOpacity>

                        }

                    </View>
                </View>
            </ScrollView>
        </View>
    );
};

export default Login;

const styles = StyleSheet.create({
    buttonText: {
        fontFamily: "yk",
        fontSize: RFValue(16),
        color: Config.maincolor,
    },
    rule :{
        fontFamily: "yk",
        fontSize: RFValue(12),
        paddingHorizontal : RFValue(10),
        paddingVertical : RFValue(20),
        color: Config.maincolor,
    },
    refer :{
        fontFamily: "yk",
        fontSize: RFValue(12),
        paddingHorizontal : RFValue(10),
        paddingVertical : RFValue(10),
        color: Config.maincolor,
    },
    button: {
        backgroundColor: Config.secondcolor,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        marginTop: -RFValue(50),
        borderRadius: RFValue(10),
        height: RFValue(40),
    },
    input: {
        borderStyle: "solid",
        borderColor: "#E7E9F2",
        borderWidth: 1,
        borderRadius: RFValue(10),
        height: RFValue(50),
        padding: RFValue(1),
        backgroundColor: "white",
        marginTop: RFValue(20),
        justifyContent: "center",
        alignItems: "center",
    },
    label: {
        fontSize: RFValue(20),
        fontFamily: "yk",
        color: Config.textcolor,
    },
    body: {
        flex: 1,
        backgroundColor: "#FAFAFA",
        borderTopStartRadius: RFValue(110),
        borderTopEndRadius: RFValue(110),
        marginTop: -RFValue(45),
        paddingHorizontal: RFValue(30),
        paddingTop: RFValue(65),
        justifyContent: "flex-start",
    },
    header: {
        justifyContent: "center",
        alignItems: "center",
        paddingTop: RFValue(10),
        zIndex: 10,
    },
    container: {
        flex: 1,
        backgroundColor: Config.maincolor,
    },
});
